export const data = [
  {
    name: 'Природознавчі науки',
    udk: '5',
    bbk: '2',
  },
  {
    name: 'Природознавчі науки в цілому',
    udk: '5',
    bbk: '20',
  },
  {
    name: 'Людина і навколишне середовище. Охорона природи',
    udk: '502.1',
    bbk: '20.1',
  },
  {
    name: 'Охорона природи в Україні',
    udk: '502.1(477)',
    bbk: '20.1(4Укр)',
  },
  {
    name: 'Охорона природи в окремих країнах',
    udk: '502.1(ТТД)',
    bbk: '20.1(2/8)',
  },
  {
    name: 'Уфологія',
    udk: '001.94',
    bbk: '20.3',
  },
  {
    name: 'Глобалістика (основні проблеми суспільства)',
    udk: '',
    bbk: '20.7',
  },

  {
    name: 'Математика',
    udk: '51',
    bbk: '22.1',
  },
  {
    name: 'Елементарна математика',
    udk: '51',
    bbk: '22.10',
  },
  {
    name: 'Вища математика',
    udk: '51',
    bbk: '22.11',
  },
  {
    name: 'Основи математики. Математична логіка',
    udk: '510',
    bbk: '22.12',
  },
  {
    name: 'Основи математики',
    udk: '510.21',
    bbk: '22.121',
  },
  {
    name: 'Математична логіка',
    udk: '510.6',
    bbk: '22.122',
  },
  {
    name: 'Теорія моделей',
    udk: '510.8',
    bbk: '22.123',
  },
  {
    name: 'Алгебраїчна логіка',
    udk: '510.635.8',
    bbk: '22.124',
  },
  {
    name: 'Теорія множин',
    udk: '510.3',
    bbk: '22.126',
  },
  {
    name: 'Теорія алгоритмів і обчислювальних функцій. Конструктивний аналіз',
    udk: '510.57 510.477',
    bbk: '22.127',
  },
  {
    name: 'Теорія чисел',
    udk: '511',
    bbk: '22.13',
  },
  {
    name: 'Арифметика',
    udk: '511.1',
    bbk: '22.130',
  },
  {
    name: 'Алгебра',
    udk: '512',
    bbk: '22.14',
  },
  {
    name: 'Елементарна алгебра',
    udk: '512.1',
    bbk: '22.141',
  },
  {
    name: 'Лінійна і полілінійна алгебра. Теорія матриць',
    udk: '512.64',
    bbk: '22.143',
  },
  {
    name: 'Загальна алгебра',
    udk: '512.5',
    bbk: '22.144',
  },
  {
    name: 'Групи і напівгрупи',
    udk: '512.5',
    bbk: '22.144.1',
  },
  {
    name: 'Напівгрупи',
    udk: '512.53',
    bbk: '22.144.11',
  },
  {
    name: 'Групи',
    udk: '512.54',
    bbk: '22.144.12',
  },
  {
    name: 'Кільця і модулі',
    udk: '512.55',
    bbk: '22.144.3',
  },
  {
    name: 'Структури',
    udk: '512.56',
    bbk: '22.144.4',
  },
  {
    name: 'Вільні алгебри',
    udk: '512.57',
    bbk: '22.144.5',
  },
  {
    name: 'Категорії',
    udk: '512.58',
    bbk: '22.144.6',
  },
  {
    name: 'Поля и множини',
    udk: '512.62',
    bbk: '22.144.7',
  },
  {
    name: 'Гомологічна алгебра',
    udk: '512.66',
    bbk: '22.145',
  },
  {
    name: 'Диференціальна алгебра',
    udk: '512.628.2',
    bbk: '22.146',
  },
  {
    name: 'Разностна алгебра',
    udk: '512.628.4',
    bbk: '22.146',
  },
  {
    name: 'Алгебраїчна геометрія',
    udk: '512.7',
    bbk: '22.147',
  },
  {
    name: 'Групи Лі',
    udk: '512.81',
    bbk: '22.148',
  },
  {
    name: 'Геометрія',
    udk: '514',
    bbk: '22.151',
  },
  {
    name: 'Елементарна геометрія',
    udk: '514.11',
    bbk: '22.151.0',
  },
  {
    name: 'Основи геометрії. Аксіоматика',
    udk: '514.01',
    bbk: '22.151.1',
  },
  {
    name: 'Неевклідова геометрія',
    udk: '514.13',
    bbk: '22.151.2',
  },
  {
    name: 'Геометрія Лобачевського (гіперболічна геометрія)',
    udk: '514.132',
    bbk: '22.151.21',
  },
  {
    name: 'Нарисна геометрія',
    udk: '514.18',
    bbk: '22.151.34',
  },
  {
    name: 'Геометрії над алгебрами',
    udk: '514.16',
    bbk: '22.151.45',
  },
  {
    name: 'Алгебраїчні та аналітичні методи в геометрії',
    udk: '514.74',
    bbk: '22.151.5',
  },
  {
    name: 'Векторна алгебра',
    udk: '514.742.2',
    bbk: '22.151.51',
  },
  {
    name: 'Аналітична геометрія',
    udk: '514.12',
    bbk: '22.151.54',
  },
  {
    name: "Геометричні об'єкти",
    udk: '514.747',
    bbk: '22.151.56',
  },
  {
    name: 'Диференціальна геометрія',
    udk: '514.7',
    bbk: '22.151.6',
  },
  {
    name: 'Топологія',
    udk: '515.1',
    bbk: '22.152',
  },
  {
    name: 'Математичний аналіз',
    udk: '517',
    bbk: '22.161',
  },
  {
    name: 'Диференціальне числення',
    udk: '517.2',
    bbk: '22.161.1',
  },
  {
    name: 'Інтегральне числення',
    udk: '517.3',
    bbk: '22.161.1',
  },
  {
    name: 'Теорія функцій',
    udk: '517.5',
    bbk: '22.161.5',
  },
  {
    name: 'Функціональний аналіз',
    udk: '517.98',
    bbk: '22.162',
  },
  {
    name: 'Теорія ймовірностей',
    udk: '519.21',
    bbk: '22.171',
  },
  {
    name: 'Математична статистика',
    udk: '519.22',
    bbk: '22.172',
  },
  {
    name: 'Комбінаторний аналіз',
    udk: '519.101',
    bbk: '22.174.1',
  },
  {
    name: 'Теорія графів',
    udk: '519.17',
    bbk: '22.174.2',
  },
  {
    name: 'Математична кібернетика',
    udk: '519.7',
    bbk: '22.18',
  },
  {
    name: 'Математичні теорії та методи дослідження операцій',
    udk: '519.8',
    bbk: '22.18',
  },
  {
    name: 'Математичне програмування',
    udk: '519.85',
    bbk: '22.183.4',
  },
  {
    name: 'Штучний інтелект',
    udk: '004.8',
    bbk: '22.186',
  },
  {
    name: 'Обчислювальна математика',
    udk: '519.6',
    bbk: '22.19',
  },
  {
    name: 'Механіка',
    udk: '531',
    bbk: '22.2',
  },
  {
    name: 'Статика',
    udk: '531.2',
    bbk: '22.232',
  },
  {
    name: 'Кінематика',
    udk: '531.1',
    bbk: '22.234',
  },
  {
    name: 'Динаміка',
    udk: '531.3',
    bbk: '22.236',
  },
  {
    name: 'Фізика',
    udk: '53',
    bbk: '22.3',
  },
  {
    name: 'Теоретична фізика',
    udk: '530',
    bbk: '22.31',
  },
  {
    name: 'Акустика',
    udk: '534',
    bbk: '22.32',
  },
  {
    name: 'Електрика і магнетизм',
    udk: '537',
    bbk: '22.33',
  },
  {
    name: 'Електростатика',
    udk: '537.2',
    bbk: '22.331',
  },
  {
    name: 'Електричний струм',
    udk: '537.3',
    bbk: '22.332',
  },
  {
    name: 'Фізика плазми',
    udk: '533.9',
    bbk: '22.333',
  },
  {
    name: 'Магнетизм',
    udk: '537.6',
    bbk: '22.334',
  },
  {
    name: 'Оптика',
    udk: '535',
    bbk: '22.34',
  },
  {
    name: 'Фотометрія',
    udk: '535.24',
    bbk: '22.341.3',
  },
  {
    name: 'Теорія світла',
    udk: '535 -1/ - 3',
    bbk: '22.343.1',
  },
  {
    name: 'Молекулярна фізика',
    udk: '539.19',
    bbk: '22.36',
  },
  {
    name: 'Термометрія. Термометри',
    udk: '536.51',
    bbk: '22.361.51',
  },
  {
    name: 'Фізика твердого тіла',
    udk: '538.9',
    bbk: '22.37',
  },
  {
    name: 'Кристалографія',
    udk: '548',
    bbk: '22.37',
  },
  {
    name: 'Ядерна фізика',
    udk: '539.1',
    bbk: '22.38',
  },
  {
    name: 'Горологія. Хронологія. Календар',
    udk: '006.92/95',
    bbk: '22.61',
  },
  {
    name: 'Хімія',
    udk: '54',
    bbk: '24',
  },
  {
    name: 'Аналітична хімія',
    udk: '543',
    bbk: '24.4',
  },
  {
    name: 'Фізична хімія',
    udk: '544',
    bbk: '24.5',
  },
  {
    name: 'Хімічна термодинаміка',
    udk: '544.3',
    bbk: '24.53',
  },
  {
    name: 'Хімічна кінетика. Каталіз.',
    udk: '544.4',
    bbk: '24.54',
  },
  {
    name: 'Хімія високо енергетичних процесів',
    udk: '544.5',
    bbk: '24.5',
  },
  {
    name: 'Електрохімія',
    udk: '544.6',
    bbk: '24.57',
  },
  {
    name: 'Колоїдна хімія',
    udk: '544.77',
    bbk: '24.6',
  },
  {
    name: 'Неорганічна хімія',
    udk: '546',
    bbk: '24.1',
  },
  {
    name: 'Органічна хімія',
    udk: '547',
    bbk: '24.2',
  },
  {
    name: 'Загальна геологія',
    udk: '551',
    bbk: '26',
  },
  {
    name: 'Загальна будова Землі',
    udk: '551.1',
    bbk: '26.0',
  },
  {
    name: 'Геологія. Науки про Землю',
    udk: '55',
    bbk: '26.3',
  },
  {
    name: 'Геофізика',
    udk: '550.3',
    bbk: '26.2',
  },
  {
    name: 'Гідросфера',
    udk: '502.51',
    bbk: '26.22',
  },
  {
    name: 'Фізична океанографія',
    udk: '551.46',
    bbk: '26.221',
  },
  {
    name: 'Метеорологія',
    udk: '551.5',
    bbk: '26.23',
  },
  {
    name: 'Атмосфера',
    udk: '502.3',
    bbk: '26.23',
  },
  {
    name: 'Кліматологія',
    udk: '551.58',
    bbk: '26.237',
  },
  {
    name: 'Геобіологія',
    udk: '550.7',
    bbk: '26.3 28.0',
  },
  {
    name: 'Геохімія',
    udk: '550.4',
    bbk: '26.30',
  },
  {
    name: 'Мінералогія',
    udk: '549',
    bbk: '26.31',
  },
  {
    name: 'Літосфера',
    udk: '502.52',
    bbk: '26.31',
  },
  {
    name: 'Вулканологія',
    udk: '551.21',
    bbk: '26.325',
  },
  {
    name: 'Геохронологія',
    udk: '550.93',
    bbk: '26.33',
  },
  {
    name: 'Родовища корисних копалин',
    udk: '553',
    bbk: '26.34',
  },
  {
    name: 'Географія',
    udk: '91',
    bbk: '26.8',
  },
  {
    name: 'Фізична географія',
    udk: '911.2',
    bbk: '26.82',
  },
  {
    name: 'Спелеологія',
    udk: '551.44',
    bbk: '26.823',
  },
  {
    name: 'Краєзнавство',
    udk: '908',
    bbk: '26.89',
  },
  {
    name: 'Біологічні науки',
    udk: '57',
    bbk: '28',
  },
  {
    name: 'Антропологія',
    udk: '572',
    bbk: '28.71',
  },
  {
    name: 'Загальна й теоретична біологія',
    udk: '573',
    bbk: '28.0',
  },
  {
    name: 'Загальна екологія',
    udk: '574',
    bbk: '28.080',
  },
  {
    name: 'Генетика та цитогенетика',
    udk: '575',
    bbk: '28.04',
  },
  {
    name: 'Цитологія',
    udk: '576',
    bbk: '28.05',
  },
  {
    name: 'Біохімія. Біофізика',
    udk: '577',
    bbk: '28.07',
  },
  {
    name: 'Імунітет',
    udk: '612.017',
    bbk: '28.074',
  },
  {
    name: 'Вірусологія',
    udk: '578',
    bbk: '28.3',
  },
  {
    name: 'Мікробіологія',
    udk: '579',
    bbk: '28.4',
  },
  {
    name: 'Ботаніка',
    udk: '58',
    bbk: '28.5',
  },
  {
    name: 'Фізіологія рослин',
    udk: '581.1',
    bbk: '28.57',
  },
  {
    name: 'Екологія рослин',
    udk: '581.5',
    bbk: '28.53',
  },
  {
    name: 'Зоологія',
    udk: '59',
    bbk: '28.6',
  },
  {
    name: 'Фізіологія тварин',
    udk: '591.1',
    bbk: '28.673',
  },
  {
    name: 'Анатомія тварин',
    udk: '591.4',
    bbk: '28.66',
  },
  {
    name: 'Екологія тварин',
    udk: '591.5',
    bbk: '28.680',
  },
  {
    name: 'Біологія людини',
    udk: '611/612',
    bbk: '28.70',
  },
  {
    name: 'Анатомія людини',
    udk: '611',
    bbk: '28.706',
  },
  {
    name: 'Фізіологія людини',
    udk: '612',
    bbk: '28.707',
  },
  {
    name: 'Машинобудування. Техніка загалом',
    udk: '62',
    bbk: '3',
  },
  {
    name: 'Матеріалознавство',
    udk: '620.2',
    bbk: '30',
  },
  {
    name: 'Стандартизація',
    udk: '006',
    bbk: '30ц',
  },
  {
    name: 'Метрологія',
    udk: '006.91',
    bbk: '30.10',
  },
  {
    name: 'Енергетика',
    udk: '620',
    bbk: '31',
  },
  {
    name: 'Електротехніка',
    udk: '621.3',
    bbk: '31.2',
  },
  {
    name: 'Теплові двигуни',
    udk: '621.1',
    bbk: '31.36',
  },
  {
    name: 'Холодильна техніка',
    udk: '621.56/59',
    bbk: '31.392',
  },
  {
    name: 'Атомна енергетика',
    udk: '621.039',
    bbk: '31.4',
  },
  {
    name: 'Гідравлічні машини',
    udk: '621.22',
    bbk: '31.56',
  },
  {
    name: 'Компресори',
    udk: '621.51/54',
    bbk: '31.7',
  },
  {
    name: 'Кібернетика',
    udk: '007',
    bbk: '32.81',
  },
  {
    name: 'Радіотехніка',
    udk: '621.37',
    bbk: '32.84',
  },
  {
    name: 'Електроніка',
    udk: '621.38',
    bbk: '32.85',
  },
  {
    name: 'Телекомунікація. Електрозв’язок',
    udk: '621.39',
    bbk: '32.88 ; 32.94',
  },
  {
    name: 'Телемеханіка',
    udk: '621.398',
    bbk: '32.968',
  },
  {
    name: 'Обчислювальна техніка. Комп’ютерна наука. Інформаційні технології',
    udk: '004',
    bbk: '32.97',
  },
  {
    name: 'Прикладні інформаційні технології. Комп’ютерна графіка',
    udk: '004.9',
    bbk: '32.973 -018.2',
  },
  {
    name: 'Гірнича справа',
    udk: '622',
    bbk: '33',
  },
  {
    name: 'Добування корисних копалин',
    udk: '622.3',
    bbk: '33.3',
  },
  {
    name: 'Металознавство',
    udk: '669.01',
    bbk: '34.2',
  },
  {
    name: 'Металургія',
    udk: '669',
    bbk: '34.3',
  },
  {
    name: 'Порошкова металургія',
    udk: '621.762',
    bbk: '34.39',
  },
  {
    name: 'Деталі машин і механізмів',
    udk: '621.81/85',
    bbk: '34.44',
  },
  {
    name: 'Ковальське виробництво',
    udk: '621.73',
    bbk: '34.623',
  },
  {
    name: 'Ливарне виробництво',
    udk: '621.74',
    bbk: '34.61',
  },
  {
    name: 'Токарні роботи',
    udk: '621.941',
    bbk: '34.632',
  },
  {
    name: 'Зварювання',
    udk: '621.791',
    bbk: '34.641',
  },
  {
    name: 'Слюсарна справа',
    udk: '683.3',
    bbk: '34.671',
  },
  {
    name: 'Приладобудування',
    udk: '681.2',
    bbk: '34.9',
  },
  {
    name: 'Хімічна технологія',
    udk: '66',
    bbk: '35',
  },
  {
    name: 'Керамічна промисловість',
    udk: '666.3/7',
    bbk: '35.41',
  },
  {
    name: 'Переробка нафти. Нафтопродукти',
    udk: '665.6/7',
    bbk: '35.514',
  },
  {
    name: 'Олії. Жири. Віск',
    udk: '665.1/3',
    bbk: '35.78',
  },
  {
    name: 'Харчове виробництво',
    udk: '663/664',
    bbk: '36',
  },
  {
    name: 'Крохмальне виробництво',
    udk: '664.2',
    bbk: '36.85',
  },
  {
    name: 'Цукрове виробництво',
    udk: '664.1',
    bbk: '36.84',
  },
  {
    name: 'Виноробство',
    udk: '663.1/5',
    bbk: '36.87',
  },
  {
    name: 'Яйця',
    udk: '637.4',
    bbk: '36.93',
  },
  {
    name: 'Тютюнова промисловість',
    udk: '663.97',
    bbk: '36.98',
  },
  {
    name: 'Кулінарія',
    udk: '641/642',
    bbk: '36.99',
  },
  {
    name: 'Хлібопекарське виробництво',
    udk: '664.6/7',
    bbk: '36.82/83',
  },
  {
    name: 'Деревообробна промисловість',
    udk: '674',
    bbk: '37.1',
  },
  {
    name: 'Меблева промисловість',
    udk: '684',
    bbk: '37.134.1',
  },
  {
    name: 'Шкіряна промисловість',
    udk: '675',
    bbk: '37.252/253',
  },
  {
    name: 'Текстильна промисловість',
    udk: '677',
    bbk: '37.23',
  },
  {
    name: 'Швейне виробництво',
    udk: '687.1/4',
    bbk: '37.24',
  },
  {
    name: 'Взуттєве виробництво',
    udk: '685.34',
    bbk: '37.255',
  },
  {
    name: 'Рукоділля',
    udk: '689',
    bbk: '37.248',
  },
  {
    name: 'Домоведення. Служба побуту',
    udk: '64',
    bbk: '37.279',
  },
  {
    name: 'Поліграфічна промисловість',
    udk: '655',
    bbk: '37.8',
  },
  {
    name: 'Будівельна справа',
    udk: '69',
    bbk: '38',
  },
  {
    name: 'Будівельні матеріали',
    udk: '691',
    bbk: '38.3',
  },
  {
    name: 'Конструкції та споруди будівництва',
    udk: '692',
    bbk: '38.4',
  },
  {
    name: 'Будівельні роботи',
    udk: '693',
    bbk: '38.6',
  },
  {
    name: 'Столярні роботи',
    udk: '694',
    bbk: '38.635',
  },
  {
    name: 'Водопостачання. Очищення води',
    udk: '628.1',
    bbk: '38.761.1',
  },
  {
    name: 'Опалення. Вентиляція',
    udk: '628.8',
    bbk: '38.762',
  },
  {
    name: 'Перукарська справа',
    udk: '687.53',
    bbk: '38.937',
  },
  {
    name: 'Транспорт',
    udk: '629',
    bbk: '39',
  },
  {
    name: 'Автомобілі',
    udk: '629.33',
    bbk: '39.33',
  },
  {
    name: 'Залізничний транспорт',
    udk: '629.4',
    bbk: '39.2',
  },
  {
    name: 'Водний транспорт',
    udk: '629.5',
    bbk: '39.4',
  },
  {
    name: 'Авіація. Повітряний транспорт',
    udk: '629.7',
    bbk: '39.5/6',
  },
  {
    name: 'Сільське господарство',
    udk: '63',
    bbk: '4',
  },
  {
    name: 'Лісове господарство',
    udk: '630',
    bbk: '43',
  },
  {
    name: 'Грунтознавство',
    udk: '631.4',
    bbk: '40.3',
  },
  {
    name: 'Добрива',
    udk: '631.8',
    bbk: '40.40',
  },
  {
    name: 'Сільськогосподарські споруди, будівлі',
    udk: '631.2',
    bbk: '40.8',
  },
  {
    name: 'Сільськогосподарські машини',
    udk: '631.3',
    bbk: '40.72',
  },
  {
    name: 'Агротехніка',
    udk: '631.5',
    bbk: '41.4',
  },
  {
    name: 'Рослинництво. Рільництво',
    udk: '633/635',
    bbk: '42',
  },
  {
    name: 'Зернові культури',
    udk: '633.1',
    bbk: '42.11',
  },
  {
    name: 'Лікарські рослини',
    udk: '633.88',
    bbk: '42.143',
  },
  {
    name: 'Кормові трави',
    udk: '633.2/3',
    bbk: '42.2',
  },
  {
    name: 'Овочівництво',
    udk: '635',
    bbk: '42.3',
  },
  {
    name: 'Плодівництво',
    udk: '634',
    bbk: '42.35',
  },
  {
    name: 'Ягідництво',
    udk: '634.7',
    bbk: '42.358',
  },
  {
    name: 'Виноградарство',
    udk: '634.8',
    bbk: '42.36',
  },
  {
    name: 'Захист рослин',
    udk: '632',
    bbk: '44',
  },
  {
    name: 'Тваринництво',
    udk: '636/639',
    bbk: '45',
  },
  {
    name: 'Скотарство. Велика рогата худоба',
    udk: '636.2',
    bbk: '46.0',
  },
  {
    name: 'Конярство',
    udk: '636.1',
    bbk: '46.1',
  },
  {
    name: 'Свинарство',
    udk: '636.4',
    bbk: '46.5',
  },
  {
    name: 'Птахівництво',
    udk: '636.5/6',
    bbk: '46.8',
  },
  {
    name: 'Собаківництво. Кінологія',
    udk: '636.7',
    bbk: '46.73',
  },
  {
    name: 'Кішки',
    udk: '636.8',
    bbk: '46.74',
  },
  {
    name: 'Хутрові звірі',
    udk: '636.93',
    bbk: '47.1',
  },
  {
    name: 'Бджільництво',
    udk: '638.1',
    bbk: '46.91',
  },
  {
    name: 'Шовківництво',
    udk: '638.2',
    bbk: '46.92',
  },
  {
    name: 'Мисливство',
    udk: '639.1',
    bbk: '47.1',
  },
  {
    name: 'Рибне господарство',
    udk: '639.2/6',
    bbk: '47.2',
  },
  {
    name: 'Ветеринарія',
    udk: '636.09',
    bbk: '48',
  },
  {
    name: 'Ветеринарна гігієна',
    udk: '614.9',
    bbk: '48.1',
  },
  {
    name: 'Медичні науки',
    udk: '61',
    bbk: '5',
  },
  {
    name: 'Охорона здоров’я',
    udk: '614',
    bbk: '51.1',
  },
  {
    name: 'Валеологія',
    udk: '61:304.3',
    bbk: '51.204.0',
  },
  {
    name: 'Гігієна загалом',
    udk: '613',
    bbk: '51.2',
  },
  {
    name: 'Медична кліматологія',
    udk: '613.1',
    bbk: '51.20',
  },
  {
    name: 'Гігієна харчування',
    udk: '613.2/3',
    bbk: '51.23',
  },
  {
    name: 'Гігієна праці. Професійні хвороби',
    udk: '613.6',
    bbk: '51.24',
  },
  {
    name: 'Епідеміологія',
    udk: '614.4',
    bbk: '51.9',
  },
  {
    name: 'Фармакологія',
    udk: '615',
    bbk: '52.8',
  },
  {
    name: 'Лікарські засоби',
    udk: '615.2/4',
    bbk: '52.81',
  },
  {
    name: 'Перша допомога',
    udk: '616-083.98',
    bbk: '53.5',
  },
  {
    name: 'Терапія',
    udk: '616-085',
    bbk: '53.5',
  },
  {
    name: 'Дієтотерапія',
    udk: '615.874',
    bbk: '53.51',
  },
  {
    name: 'Кардіологія',
    udk: '616.1',
    bbk: '54.10/11',
  },
  {
    name: 'Пульмонологія',
    udk: '616.2',
    bbk: '54.12',
  },
  {
    name: 'Гастроентерологія',
    udk: '616.3',
    bbk: '54.13',
  },
  {
    name: 'Ендокринологія',
    udk: '616.4',
    bbk: '54.15',
  },
  {
    name: 'Травматологія',
    udk: '616.7',
    bbk: '54.18',
  },
  {
    name: 'Хірургія',
    udk: '616-089',
    bbk: '54.5',
  },
  {
    name: 'Ортопедія',
    udk: '617.3',
    bbk: '54.58',
  },
  {
    name: 'СНІД',
    udk: '616.98',
    bbk: '55.148',
  },
  {
    name: 'Фтизіатрія',
    udk: '616-002.5',
    bbk: '55.4',
  },
  {
    name: 'Онкологія',
    udk: '616-006',
    bbk: '55.6',
  },
  {
    name: 'Венерологія',
    udk: '616.97',
    bbk: '55.81',
  },
  {
    name: 'Дерматологія',
    udk: '616.5',
    bbk: '55.83',
  },
  {
    name: 'Невропатологія. Психіатрія',
    udk: '616.8',
    bbk: '56.1',
  },
  {
    name: 'Нейрохірургія',
    udk: '616.8-089',
    bbk: '56.13',
  },
  {
    name: 'Психіатрія',
    udk: '159.97',
    bbk: '56.14',
  },
  {
    name: 'Стоматологія',
    udk: '616.31',
    bbk: '56.6',
  },
  {
    name: 'Офтальмологія',
    udk: '617.7',
    bbk: '56.7',
  },
  {
    name: 'Оториноларингологія',
    udk: '616.21',
    bbk: '56.8',
  },
  {
    name: 'Урологія',
    udk: '616.61/68',
    bbk: '56.9',
  },
  {
    name: 'Сексопатологія',
    udk: '616.69',
    bbk: '57.05',
  },
  {
    name: 'Гінекологія',
    udk: '618',
    bbk: '57.1',
  },
  {
    name: 'Педіатрія',
    udk: '616-053.2',
    bbk: '57.3',
  },
  {
    name: 'Статистика',
    udk: '311',
    bbk: '60.6',
  },
  {
    name: 'Демографія. Народонаселення',
    udk: '314',
    bbk: '60.7',
  },
  {
    name: 'Соціологія',
    udk: '316',
    bbk: '60.5',
  },
  {
    name: 'Соціологія культури',
    udk: '316.7',
    bbk: '60.56',
  },
  {
    name: 'Гендерні дослідження',
    udk: '305',
    bbk: '60.5',
  },
  {
    name: 'Історіографія',
    udk: '930',
    bbk: '63',
  },
  {
    name: 'Генеалогія',
    udk: '929.5',
    bbk: '63.2',
  },
  {
    name: 'Геральдика',
    udk: '929.6',
    bbk: '63.2',
  },
  {
    name: 'Історія',
    udk: '93/94',
    bbk: '63.3',
  },
  {
    name: 'Всесвітня історія',
    udk: '94(100)',
    bbk: '63.3(0)',
  },
  {
    name: 'Історія стародавнього світу',
    udk: '94(3)',
    bbk: '63.3(0)3',
  },
  {
    name: 'Історія України',
    udk: '94(477)',
    bbk: '63.3(4Укр)',
  },
  {
    name: 'Історія української діаспори у Канаді',
    udk: '94(71=161.2)',
    bbk: '63.3(7Кан=Укр)',
  },
  {
    name: 'Археологія',
    udk: '902/904',
    bbk: '63.4',
  },
  {
    name: 'Етнографія',
    udk: '39',
    bbk: '63.5',
  },
  {
    name: 'Етнографія України',
    udk: '39(477)',
    bbk: '63.52(4Укр)',
  },
  {
    name: 'Економіка',
    udk: '33',
    bbk: '65',
  },
  {
    name: 'Економіка України',
    udk: '33(477)',
    bbk: '65.9(4Укр)',
  },
  {
    name: 'Основи економічної теорії',
    udk: '330.1',
    bbk: '65.01',
  },
  {
    name: 'Мікроекономіка',
    udk: '330.101.542',
    bbk: '65.012.1',
  },
  {
    name: 'Макроекономіка',
    udk: '330.101.541',
    bbk: '65.012.2',
  },
  {
    name: 'Історія економічної думки',
    udk: '330.8',
    bbk: '65.02',
  },
  {
    name: 'Історія економічної думки в Україні',
    udk: '330.8(477)',
    bbk: '65.02(4Укр)',
  },
  {
    name: 'Економічна історія. Стадії економічного розвитку',
    udk: '330.34',
    bbk: '65.03',
  },
  {
    name: 'Економічна географія',
    udk: '911.3:33',
    bbk: '65.04',
  },
  {
    name: 'Економічна географія окремих країн',
    udk: '911.3:33](4/9)',
    bbk: '65.049(2/8)',
  },
  {
    name: 'Економічна географія України',
    udk: '911.3:33](477)',
    bbk: '65.049(4Укр)',
  },
  {
    name: 'Управління економікою',
    udk: '338.24',
    bbk: '65.050',
  },
  {
    name: 'Менеджмент',
    udk: '005',
    bbk: '65.050.2',
  },
  {
    name: 'Діловодство',
    udk: '005.92',
    bbk: '65.050.286',
  },
  {
    name: 'Управління економікою в окремих країнах',
    udk: '338.24(ТТД)',
    bbk: '65.050.9',
  },
  {
    name: 'Управління економікою в Україні',
    udk: '338.24(477)',
    bbk: '65.050.9(4Укр)',
  },
  {
    name: 'Економічна статистика',
    udk: '311:33',
    bbk: '65.051',
  },
  {
    name: 'Облік. Бухгалтерський облік',
    udk: '657',
    bbk: '65.052',
  },
  {
    name: 'Економічний аналіз',
    udk: '33.021',
    bbk: '65.053',
  },
  {
    name: 'Планування. Прогнозування',
    udk: '338.26 338.27',
    bbk: '65.23',
  },
  {
    name: 'Економіка праці',
    udk: '331',
    bbk: '65.24',
  },
  {
    name: 'Економіка праці в Україні',
    udk: '331(477)',
    bbk: '65.24(4Укр)',
  },
  {
    name: 'Охорона праці',
    udk: '331.45',
    bbk: '65.248',
  },
  {
    name: 'Ціни. Ціноутворення',
    udk: '338.5',
    bbk: '65.25',
  },
  {
    name: 'Фінанси. Грошовий обіг. Кредит',
    udk: '336',
    bbk: '65.26',
  },
  {
    name: 'Соціальна допомога. Соціальне забезпечення',
    udk: '364.3',
    bbk: '65.27',
  },
  {
    name: 'Економіка охорони навколишнього середовища',
    udk: '502.17:33',
    bbk: '65.28',
  },
  {
    name: 'Економіка підприємства',
    udk: '658',
    bbk: '65.29',
  },
  {
    name: 'Економіка промисловості',
    udk: '338.4',
    bbk: '65.30',
  },
  {
    name: 'Економіка хімічної промисловості',
    udk: '338.45:66',
    bbk: '65.306.0',
  },
  {
    name: 'Економіка галузей машинобудування',
    udk: '338.45:621',
    bbk: '65.305.851.5',
  },
  {
    name: 'Економіка будівництва',
    udk: '338.45:69',
    bbk: '65.31',
  },
  {
    name: 'Економіка сільського господарства',
    udk: '338.43',
    bbk: '65.32',
  },
  {
    name: 'Економіка транспорту',
    udk: '338.47',
    bbk: '65.37',
  },
  {
    name: 'Економіка зв’язку',
    udk: '338.47',
    bbk: '65.38',
  },
  {
    name: 'Економіка залізничного транспорту',
    udk: '338.47:656.2',
    bbk: '65.372',
  },
  {
    name: 'Економіка автодорожнього транспорту',
    udk: '338.47:656.13',
    bbk: '65.373',
  },
  {
    name: 'Економіка водного транспорту',
    udk: '338.47:656.6',
    bbk: '65.374',
  },
  {
    name: 'Економіка повітряного транспорту',
    udk: '338.47:656.7',
    bbk: '65.375',
  },
  {
    name: 'Економіка трубопровідного транспорту',
    udk: '338.47:656.56',
    bbk: '65.377',
  },
  {
    name: 'Економіка інформатики',
    udk: '330.47',
    bbk: '65.39',
  },
  {
    name: 'Економіка торгівлі',
    udk: '339.1',
    bbk: '65.42',
  },
  {
    name: 'Внутрішня торгівля',
    udk: '339.3',
    bbk: '65.422',
  },
  {
    name: 'Економіка житлово-комунального господарства',
    udk: '332.8',
    bbk: '65.44',
  },
  {
    name: 'Зовнішня торгівля. Міжнародна торгівля',
    udk: '339.5',
    bbk: '65.843',
  },
  {
    name: 'Світова економіка',
    udk: '339',
    bbk: '65.5',
  },
  {
    name: 'Міжнародні економічні відносини',
    udk: '339.9',
    bbk: '65.58',
  },
  {
    name: 'Економіка окремих країн',
    udk: '338(ТТД)',
    bbk: '65.9(4/8)',
  },
  {
    name: 'Економіка України',
    udk: '338(477)',
    bbk: '65.9(4Укр)',
  },
  {
    name: 'Політологія',
    udk: '32-027.21',
    bbk: '66.0',
  },
  {
    name: 'Внутрішня політика. Внутрішнє становище',
    udk: '323',
    bbk: '66.3',
  },
  {
    name: 'Внутрішня політика України',
    udk: '323(477)',
    bbk: '66.3(4Укр)',
  },
  {
    name: 'Персоналії політичних діячів',
    udk: '32(4/9)(092)',
    bbk: '66.3(2/8)8',
  },
  {
    name: 'Виборчі компанії в Україні',
    udk: '324(477)',
    bbk: '66.3(4Укр)68',
  },
  {
    name: 'Зовнішня політика. Дипломатія',
    udk: '327',
    bbk: '66.4',
  },
  {
    name: 'Зовнішня політика України',
    udk: '327(477)',
    bbk: '66.4(4Укр)',
  },
  {
    name: 'Політичні партії та рухи',
    udk: '329',
    bbk: '66.6',
  },
  {
    name: 'Політичні партії в Україні',
    udk: '329(477)',
    bbk: '66.69(4Укр)',
  },
  {
    name: 'Національні рухи. Національні відносини',
    udk: '329.73',
    bbk: '66.5',
  },
  {
    name: 'Рух і організації молоді',
    udk: '329.78',
    bbk: '66.75',
  },
  {
    name: 'Загальна теорія права',
    udk: '340.12',
    bbk: '67.0',
  },
  {
    name: 'Історія держави і права',
    udk: '340.15',
    bbk: '67.2',
  },
  {
    name: 'Конституційне право',
    udk: '342',
    bbk: '67.300',
  },
  {
    name: 'Права людини',
    udk: '342.7',
    bbk: '67.300.3',
  },
  {
    name: 'Виборче право',
    udk: '342.8',
    bbk: '67.300.5',
  },
  {
    name: 'Адміністративне право',
    udk: '342.9',
    bbk: '67.301',
  },
  {
    name: 'Фінансове право',
    udk: '347.73',
    bbk: '67.302',
  },
  {
    name: 'Господарське право',
    udk: '346',
    bbk: '67.303',
  },
  {
    name: 'Цивільне право',
    udk: '347',
    bbk: '67.304',
  },
  {
    name: 'Сімейне право',
    udk: '347.6',
    bbk: '67.304.7',
  },
  {
    name: 'Спадкове право',
    udk: '347.65/68',
    bbk: '67.304.8',
  },
  {
    name: 'Трудове право',
    udk: '349.2',
    bbk: '67.305',
  },
  {
    name: 'Торговельне право',
    udk: '347.7',
    bbk: '67.304.6',
  },
  {
    name: 'Авторське право',
    udk: '347.78',
    bbk: '67.304.3',
  },
  {
    name: 'Патентне право',
    udk: '347.77',
    bbk: '67.304.41',
  },
  {
    name: 'Морське право',
    udk: '347.79',
    bbk: '67.304.41',
  },
  {
    name: 'Цивільне процесуальне право',
    udk: '347.9',
    bbk: '67.310',
  },
  {
    name: 'Кримінальне право',
    udk: '343',
    bbk: '67.308',
  },
  {
    name: 'Кримінально-процесуальне право',
    udk: '343.13',
    bbk: '67.311',
  },
  {
    name: 'Земельне право',
    udk: '349.41',
    bbk: '67.307',
  },
  {
    name: 'Аграрне право',
    udk: '349.42',
    bbk: '67.307',
  },
  {
    name: 'Житлове право',
    udk: '349.44',
    bbk: '67.304.211.33',
  },
  {
    name: 'Екологічне право',
    udk: '349.6',
    bbk: '67.307',
  },
  {
    name: 'Міжнародне право',
    udk: '341.1/8',
    bbk: '67.5',
  },
  {
    name: 'Міжнародне приватне право. Колізійне право',
    udk: '341.9',
    bbk: '67.52',
  },
  {
    name: 'Кримінологія',
    udk: '343.9',
    bbk: '67.61',
  },
  {
    name: 'Криміналістика',
    udk: '343.98',
    bbk: '67.62',
  },
  {
    name: 'Судова медицина',
    udk: '340.6',
    bbk: '67.63',
  },
  {
    name: 'Судова психіатрія',
    udk: '340.63',
    bbk: '67.64',
  },
  {
    name: 'Адвокатура',
    udk: '347.965',
    bbk: '67.76',
  },
  {
    name: 'Прокуратура',
    udk: '343.163',
    bbk: '67.72',
  },
  {
    name: 'Арбітраж',
    udk: '347.918',
    bbk: '67.74',
  },
  {
    name: 'Нотаріат',
    udk: '347.961',
    bbk: '67.75',
  },
  {
    name: 'Нотаріат в Україні',
    udk: '347.961(477)',
    bbk: '67.75',
  },
  {
    name: 'Військова справа. Збройні сили.',
    udk: '355/359',
    bbk: '68',
  },
  {
    name: 'Загальні питання науки і культури',
    udk: '00',
    bbk: '70',
  },
  {
    name: 'Культура. Культурологія',
    udk: '008',
    bbk: '71',
  },
  {
    name: 'Філософія культури',
    udk: '130.2',
    bbk: '71.0',
  },
  {
    name: 'Історія культури',
    udk: '930.85',
    bbk: '71.3',
  },
  {
    name: 'Організація культури. Управління. Економіка. Статистика',
    udk: '304',
    bbk: '71.4',
  },
  {
    name: 'Наука',
    udk: '001',
    bbk: '72',
  },
  {
    name: 'Історія науки',
    udk: '001(091)',
    bbk: '72.3',
  },
  {
    name: 'Інформатика. Документація. Науково-технічна інформація',
    udk: '002',
    bbk: '73',
  },
  {
    name: 'Освіта. Виховання. Навчання',
    udk: '37',
    bbk: '74',
  },
  {
    name: 'Теорія, принципи, методи і організація освіти',
    udk: '37.01/09',
    bbk: '74.00',
  },
  {
    name: 'Історія народної освіти і педагогічної думки',
    udk: '37.014.2',
    bbk: '74.03',
  },
  {
    name: 'Організація освіти',
    udk: '37.018',
    bbk: '74.4',
  },
  {
    name: 'Дошкільне виховання. Дошкільне навчання',
    udk: '373.2',
    bbk: '74.1',
  },
  {
    name: 'Шкільна освіта й виховання',
    udk: '373.3/5',
    bbk: '74.2',
  },
  {
    name: 'Теорія і методи виховання',
    udk: '37.035',
    bbk: '74.200',
  },
  {
    name: 'Моральне виховання',
    udk: '37.015.31:17.022.1',
    bbk: '74.200.53',
  },
  {
    name: 'Сімейне виховання',
    udk: '37.018.1',
    bbk: '74.9',
  },
  {
    name: 'Естетичне виховання',
    udk: '37.015.31:7',
    bbk: '74.200.55',
  },
  {
    name: 'Трудове виховання',
    udk: '015.31',
    bbk: '74.200.52',
  },
  {
    name: 'Дидактика',
    udk: '37.026',
    bbk: '74.202',
  },
  {
    name: 'Школознавство',
    udk: '37.091',
    bbk: '74.204',
  },
  {
    name: 'Початкова школа',
    udk: '373.3',
    bbk: '74.24',
  },
  {
    name: 'Середня школа',
    udk: '373.5',
    bbk: '74.24',
  },
  {
    name: 'Методика викладання предметів в початковій школі',
    udk: '373.3.016',
    bbk: '74.26',
  },
  {
    name: 'Методика викладання предметів в середній школі',
    udk: '373.5.016',
    bbk: '74.26',
  },
  {
    name: 'Викладання математики',
    udk: '37.016:51',
    bbk: '74.262',
  },
  {
    name: 'Викладання фізики',
    udk: '37.016:53',
    bbk: '74.265.1',
  },
  {
    name: 'Викладання рідної мови',
    udk: '37.016:81',
    bbk: '74.261.4',
  },
  {
    name: 'Позашкільна освіта. Самоосвіта',
    udk: '374',
    bbk: '74.200.58',
  },
  {
    name: 'Спеціальні школи. Спеціальна педагогіка',
    udk: '376',
    bbk: '74.3',
  },
  {
    name: 'Професійно-технічне навчання',
    udk: '377',
    bbk: '74.56',
  },
  {
    name: 'Вища освіта',
    udk: '378',
    bbk: '74.58',
  },
  {
    name: 'Шахи',
    udk: '794.1',
    bbk: '75.581',
  },
  {
    name: 'Шашки',
    udk: '794.242',
    bbk: '75.582',
  },
  {
    name: 'Спорт',
    udk: '796/799',
    bbk: '75',
  },
  {
    name: 'Теорія та методика фізичного виховання',
    udk: '796.01/09',
    bbk: '75.1',
  },
  {
    name: 'Ігри. Спортивні ігри',
    udk: '796.1/3',
    bbk: '75.5',
  },
  {
    name: 'Гімнастика',
    udk: '796.4',
    bbk: '75.6',
  },
  {
    name: 'Туризм. Альпінізм',
    udk: '796.5',
    bbk: '75.8',
  },
  {
    name: 'Авто-мото-велоспорт',
    udk: '796.6/7',
    bbk: '75.721',
  },
  {
    name: 'Важка атлетика. Спортивна боротьба',
    udk: '796.8',
    bbk: '75.712/716',
  },
  {
    name: 'Зимовий спорт',
    udk: '796.9',
    bbk: '75.719',
  },
  {
    name: 'Водний спорт',
    udk: '797.1/2',
    bbk: '75.717',
  },
  {
    name: 'Повітряний спорт',
    udk: '797.5',
    bbk: '75.724',
  },
  {
    name: 'Кінний спорт',
    udk: '798',
    bbk: '75.722',
  },
  {
    name: 'Спортивна стрільба',
    udk: '799.3',
    bbk: '75.723',
  },
  {
    name: 'Преса. Газети. Журналістика',
    udk: '070',
    bbk: '76',
  },
  {
    name: 'Загальне книгознавство',
    udk: '002',
    bbk: '76.10',
  },
  {
    name: 'Книжкова справа. Книгознавство',
    udk: '09',
    bbk: '76.11',
  },
  {
    name: 'Бібліотечна справа. Бібліотекознавство',
    udk: '02',
    bbk: '78.3',
  },
  {
    name: 'Музеї. Музеєзнавство',
    udk: '069',
    bbk: '79.1',
  },
  {
    name: 'Мова. Мовознавство. Художня література',
    udk: '8',
    bbk: '80/84',
  },
  {
    name: 'Філологічні науки в цілому',
    udk: '80',
    bbk: '80',
  },
  {
    name: 'Мовознавство. Мови',
    udk: '81',
    bbk: '81',
  },
  {
    name: 'Штучні мови',
    udk: '811',
    bbk: '81.8',
  },
  {
    name: 'Мовна політика',
    udk: '81’272',
    bbk: '81.21',
  },
  {
    name: 'Мовна політика України',
    udk: '811.161.2’272',
    bbk: '81.21(4Укр)',
  },
  {
    name: 'Українська мова',
    udk: '811.161.2',
    bbk: '81.411.1',
  },
  {
    name: 'Історія української мови',
    udk: '811.161.2’01/’08',
    bbk: '81.411.1-0',
  },
  {
    name: 'Фонетика української мови',
    udk: '811.161.2’342',
    bbk: '81.411.1-1',
  },
  {
    name: 'Граматика української мови',
    udk: '811.161.2’36',
    bbk: '81.411.1-2',
  },
  {
    name: 'Лексикологія, фразеологія української мови',
    udk: '811.161.2’373',
    bbk: '81.411.1-3',
  },
  {
    name: 'Лексикографія',
    udk: '811.161.2’374',
    bbk: '81.411.1-4',
  },
  {
    name: 'Діалектологія української мови',
    udk: '811.161.2’28',
    bbk: '81.411.1-5',
  },
  {
    name: 'Стилістика української мови',
    udk: '811.161.2’38',
    bbk: '81.411.1-7',
  },
  {
    name: 'Культура мовлення (риторика)',
    udk: '808.5',
    bbk: '81.411.1-7',
  },
  {
    name: 'Переклад',
    udk: '81’25 81.161.2’25',
    bbk: '81.411.1-7',
  },
  {
    name: 'Орфографія, правопис української мови',
    udk: '81.161.2’35',
    bbk: '81.411.1-8',
  },
  {
    name: 'Російська мова',
    udk: '811.161.1',
    bbk: '81.411.2',
  },
  {
    name: 'Білоруська мова',
    udk: '811.161.3',
    bbk: '81.411.3',
  },
  {
    name: 'Англійська мова',
    udk: '811.111',
    bbk: '81.432.1',
  },
  {
    name: 'Німецька мова',
    udk: '811.112.2',
    bbk: '81.432.4',
  },
  {
    name: 'Італійська мова',
    udk: '811.131.1',
    bbk: '81.473.1',
  },
  {
    name: 'Французька мова',
    udk: '811.133.1',
    bbk: '81.471.1',
  },
  {
    name: 'Іспанська мова',
    udk: '811.134.2',
    bbk: '81.472.1',
  },
  {
    name: 'Грецька мова',
    udk: '811.14',
    bbk: '81.45',
  },
  {
    name: 'Польська мова',
    udk: '811.162.1',
    bbk: '81.415.3',
  },
  {
    name: 'Чеська мова',
    udk: '811.162.3',
    bbk: '81.415.1',
  },
  {
    name: 'Словацька мова',
    udk: '811.162.4',
    bbk: '81.415.2',
  },
  {
    name: 'Болгарська мова',
    udk: '811.163.2',
    bbk: '81.416.2',
  },
  {
    name: 'Македонська мова',
    udk: '811.163.3',
    bbk: '81.416.3',
  },
  {
    name: 'Сербська мова',
    udk: '811.163.41',
    bbk: '81.416.4',
  },
  {
    name: 'Хорватська мова',
    udk: '811.163.42',
    bbk: '81.416.4',
  },
  {
    name: 'Словенська мова',
    udk: '811.163.6',
    bbk: '81.416.5',
  },
  {
    name: 'Балтійські мови',
    udk: '811.17',
    bbk: '81.42',
  },
  {
    name: 'Єврейська мова',
    udk: '811.411.16',
    bbk: '81.432.5',
  },
  {
    name: 'Арабська мова',
    udk: '811.411.21',
    bbk: '81.61',
  },
  {
    name: 'Угорська мова',
    udk: '811.511.141',
    bbk: '81.665.2',
  },
  {
    name: 'Татарська мова',
    udk: '811.512.145',
    bbk: '81.632.3',
  },
  {
    name: 'Японська мова',
    udk: '811.521',
    bbk: '81.754.42',
  },
  {
    name: 'Корейська мова',
    udk: '811.531',
    bbk: '81.754.41',
  },
  {
    name: 'Китайська мова',
    udk: '811.581',
    bbk: '81.711',
  },
  {
    name: 'Фольклор',
    udk: '398',
    bbk: '82',
  },
  {
    name: 'Фольклор як джерело лінгвістики та філології',
    udk: '801.8',
    bbk: '82',
  },
  {
    name: 'Літературознавство. Художня література',
    udk: '82',
    bbk: '83/84',
  },
  {
    name: 'Теорія літератури',
    udk: '82.0',
    bbk: '83.0',
  },
  {
    name: 'Критика літератури. Літературознавство',
    udk: '82.09',
    bbk: '83.3',
  },
  {
    name: 'Критика української літератури',
    udk: '821.161.2.09',
    bbk: '83.3(4Укр)',
  },
  {
    name: 'Світова література',
    udk: '821(100)',
    bbk: '84(0)',
  },
  {
    name: 'Художня література окремих країн',
    udk: '821',
    bbk: '84',
  },
  {
    name: 'Українська література в цілому',
    udk: '821(477)',
    bbk: '84(4Укр)',
  },
  {
    name: 'Українська художня література',
    udk: '821.161.2',
    bbk: '84(4Укр)',
  },
  {
    name: 'Проза українська',
    udk: '821.161.2-3',
    bbk: '84(4Укр)-4',
  },
  {
    name: 'Казки українські',
    udk: '821.161.2-343',
    bbk: '84(4Укр)-445',
  },
  {
    name: 'Поезія українська',
    udk: '821.161.2-1',
    bbk: '84(4укр)-5',
  },
  {
    name: 'Драматургія українська',
    udk: '821.161.2-2',
    bbk: '84(4Укр)-6',
  },
  {
    name: 'Гумор, сатира українська',
    udk: '821.161.2-7',
    bbk: '84(4Укр)-7',
  },
  {
    name: 'Давня українська література',
    udk: '821.161.2’01',
    bbk: '84(4Укр)4',
  },
  {
    name: 'Середньовічний період української літератури',
    udk: '821.161.2’04',
    bbk: '84(4Укр)4',
  },
  {
    name: 'Новітня та сучасна українська література',
    udk: '821.161.2’06',
    bbk: '84(4Укр)6',
  },
  {
    name: 'Англійська література',
    udk: '821.111',
    bbk: '84(4Вел)',
  },
  {
    name: 'Німецька література',
    udk: '821.112.2',
    bbk: '84(4Нім)',
  },
  {
    name: 'Голландська література',
    udk: '821.112.5',
    bbk: '84(4Гол)',
  },
  {
    name: 'Ісландська література',
    udk: '821.113.3',
    bbk: '84(4Ісл)',
  },
  {
    name: 'Датська література',
    udk: '821.113.4',
    bbk: '84(4Дат)',
  },
  {
    name: 'Норвезька література',
    udk: '821.113.5',
    bbk: '84(4Нор)',
  },
  {
    name: 'Шведська література',
    udk: '821.113.6',
    bbk: '84(4Шв)',
  },
  {
    name: 'Італійська література',
    udk: '821.131.1',
    bbk: '84(4Іта)',
  },
  {
    name: 'Французька література',
    udk: '821.133.1',
    bbk: '84(4Фра)',
  },
  {
    name: 'Іспанська література',
    udk: '821.134.2',
    bbk: '84(4Ісп)',
  },
  {
    name: 'Португальська література',
    udk: '821.134.3',
    bbk: '84(4Порт)',
  },
  {
    name: 'Румунська література',
    udk: '821.135.1',
    bbk: '84(4Рум)',
  },
  {
    name: 'Молдавська література',
    udk: '821.135.2',
    bbk: '84(4Мол)',
  },
  {
    name: 'Грецька література',
    udk: '821.14',
    bbk: '84(4Гре)',
  },
  {
    name: 'Ірландська література',
    udk: '821.152.1',
    bbk: '84(4Ірл)',
  },
  {
    name: 'Російська література',
    udk: '821.161.1',
    bbk: '84(4Рос)',
  },
  {
    name: 'Білоруська література',
    udk: '821.161.3',
    bbk: '84(4Бєа)',
  },
  {
    name: 'Польська література',
    udk: '821.162.1',
    bbk: '84(4Пол)',
  },
  {
    name: 'Чеська література',
    udk: '821.162.3',
    bbk: '84(4Чех)',
  },
  {
    name: 'Словацька література',
    udk: '821.162.4',
    bbk: '84(4Сла)',
  },
  {
    name: 'Болгарська література',
    udk: '821.163.2',
    bbk: '84(4Бол)',
  },
  {
    name: 'Македонська література',
    udk: '821.163.3',
    bbk: '84(4Мак)',
  },
  {
    name: 'Сербська література',
    udk: '821.163.41',
    bbk: '84(4Сер)',
  },
  {
    name: 'Хорватська література',
    udk: '821.163.42',
    bbk: '84(4Хор)',
  },
  {
    name: 'Словенська література',
    udk: '821.163.6',
    bbk: '84(4Сло)',
  },
  {
    name: 'Литовська література',
    udk: '821.172',
    bbk: '84(4Літ)',
  },
  {
    name: 'Латиська література',
    udk: '821.174',
    bbk: '84(4Лат)',
  },
  {
    name: 'Албанська література',
    udk: '821.18',
    bbk: '84(4Алб)',
  },
  {
    name: 'Вірменська література',
    udk: '821.19',
    bbk: '84(5Вір)',
  },
  {
    name: 'Індійська література',
    udk: '821.21',
    bbk: '84(5Інд)',
  },
  {
    name: 'Іранська література',
    udk: '821.22',
    bbk: '84(5Ірн)',
  },
  {
    name: 'Грузинська література',
    udk: '821.353.1',
    bbk: '84(5Гру)',
  },
  {
    name: 'Єврейська література',
    udk: '821.411.16',
    bbk: '84(5Ізр)',
  },
  {
    name: 'Фінська література',
    udk: '821.511.111',
    bbk: '84(4Фін)',
  },
  {
    name: 'Естонська література',
    udk: '821.511.113',
    bbk: '84(4Ест)',
  },
  {
    name: 'Угорська література',
    udk: '821.511.14',
    bbk: '84(4Уго)',
  },
  {
    name: 'Узбецька література',
    udk: '821.512.133',
    bbk: '84(5Узб)',
  },
  {
    name: 'Киргизька література',
    udk: '821.512.154',
    bbk: '84(5Кир)',
  },
  {
    name: 'Турецька література',
    udk: '821.512.161',
    bbk: '84(5Туе)',
  },
  {
    name: 'Азербайджанська література',
    udk: '821.512.162',
    bbk: '84(5Азе)',
  },
  {
    name: 'Туркменська література',
    udk: '821.512.164',
    bbk: '84(5Тур)',
  },
  {
    name: 'Кримськотатарська література',
    udk: '821.512.19',
    bbk: '84(4Укр-6Крм)',
  },
  {
    name: 'Японська література',
    udk: '821.521',
    bbk: '84(5Япо)',
  },
  {
    name: 'Китайська література',
    udk: '821.581',
    bbk: '84(5Кит)',
  },
  {
    name: 'Література Америки',
    udk: '821.111(73)',
    bbk: '84(7Спо)',
  },
  {
    name: 'Мистецтво',
    udk: '7',
    bbk: '85',
  },
  {
    name: 'Історія мистецтва',
    udk: '7.03',
    bbk: '85.03',
  },
  {
    name: 'Образотворче мистецтво',
    udk: '73/76',
    bbk: '85.1',
  },
  {
    name: 'Містобудування',
    udk: '71',
    bbk: '85.118',
  },
  {
    name: 'Ландшафтна архітектура',
    udk: '712',
    bbk: '85.118.7',
  },
  {
    name: 'Охорона історичних та культурних пам’яток',
    udk: '719',
    bbk: '85.101',
  },
  {
    name: 'Архітектура',
    udk: '72',
    bbk: '85.11',
  },
  {
    name: 'Декоративно-прикладне мистецтво',
    udk: '745/749',
    bbk: '85.12',
  },
  {
    name: 'Живопис',
    udk: '75',
    bbk: '85.14',
  },
  {
    name: 'Графіка',
    udk: '76 37.9',
    bbk: '85.15',
  },
  {
    name: 'Фотографія. Техніка кінематографії',
    udk: '77',
    bbk: '85.16',
  },
  {
    name: 'Музика',
    udk: '78',
    bbk: '85.31',
  },
  {
    name: 'Музичні інструменти',
    udk: '780.6',
    bbk: '85.315.3',
  },
  {
    name: 'Кіномистецтво',
    udk: '791',
    bbk: '85.37',
  },
  {
    name: 'Театр',
    udk: '792',
    bbk: '85.33',
  },
  {
    name: 'Естрада',
    udk: '792.7',
    bbk: '85.36',
  },
  {
    name: 'Хореографія. Танці',
    udk: '793',
    bbk: '85.32',
  },
  {
    name: 'Релігія',
    udk: '2',
    bbk: '86',
  },
  {
    name: 'Релігієзнавства',
    udk: '2-1',
    bbk: '86.2',
  },
  {
    name: 'Доісторичні та первісні релігії',
    udk: '21',
    bbk: '86.31',
  },
  {
    name: 'Релігія Далекого Сходу',
    udk: '22',
    bbk: '86.33',
  },
  {
    name: 'Буддизм',
    udk: '24',
    bbk: '86.35',
  },
  {
    name: 'Іудаїзм',
    udk: '26',
    bbk: '86.36',
  },
  {
    name: 'Християнство',
    udk: '27',
    bbk: '86.37',
  },
  {
    name: 'Біблія. Старий Завіт. Новий Завіт',
    udk: '27-23/24',
    bbk: '86.37-2',
  },
  {
    name: 'Православ’я',
    udk: '271.2',
    bbk: '86.372',
  },
  {
    name: 'Католицизм',
    udk: '272/273',
    bbk: '86.375',
  },
  {
    name: 'Протестантизм',
    udk: '274/278',
    bbk: '86.376',
  },
  {
    name: 'Іслам',
    udk: '28',
    bbk: '86.38',
  },
  {
    name: 'Коран',
    udk: '28-23',
    bbk: '86.38-2',
  },
  {
    name: 'Паранормальні явища. Окультизм',
    udk: '133',
    bbk: '86.42',
  },
  {
    name: 'Вільнодумство. Атеїзм',
    udk: '299.2',
    bbk: '86.7',
  },
  {
    name: 'Філософія',
    udk: '1',
    bbk: '87',
  },
  {
    name: 'Історія філософії',
    udk: '1(091)',
    bbk: '87.3',
  },
  {
    name: 'Історія філософії України',
    udk: '1(477)(091)',
    bbk: '87.3(4Укр)',
  },
  {
    name: 'Метафізика. Онтологія',
    udk: '111',
    bbk: '87.21',
  },
  {
    name: 'Основні концепції і закони',
    udk: '130.1',
    bbk: '87.21',
  },
  {
    name: 'Метафізика духовного життя',
    udk: '130.3',
    bbk: '87.21',
  },
  {
    name: 'Теорія пізнання. Гносеологія. Епістологія',
    udk: '165',
    bbk: '87.22',
  },
  {
    name: 'Філософія політики',
    udk: '321.01',
    bbk: '87.666.6',
  },
  {
    name: 'Філософія права',
    udk: '340.12',
    bbk: '87.666.7',
  },
  {
    name: 'Етика',
    udk: '17',
    bbk: '87.7',
  },
  {
    name: 'Естетика',
    udk: '111.852',
    bbk: '87.8',
  },
  {
    name: 'Космологія. Філософія природи . Діалектика',
    udk: '113/119',
    bbk: '87',
  },
  {
    name: 'Фемінізм',
    udk: '141.72',
    bbk: '66.1',
  },
  {
    name: 'Логіка',
    udk: '16',
    bbk: '87.4',
  },
  {
    name: 'Етикет',
    udk: '172',
    bbk: '87.774',
  },
  {
    name: 'Психологія',
    udk: '159.9',
    bbk: '88',
  },
  {
    name: 'Розвиток психіки. Порівняльна психологія',
    udk: '159.92',
    bbk: '88.2',
  },
  {
    name: 'Психофізіологія. Загальна психологія',
    udk: '159.91',
    bbk: '88.3',
  },
  {
    name: 'Дитяча психологія',
    udk: '159.922.7',
    bbk: '88.8',
  },
  {
    name: 'Психологія особистості. Психологічні типи',
    udk: '159.923',
    bbk: '88.37',
  },
  {
    name: 'Прикладна психологія. Психологія окремих видів діяльності',
    udk: '159.98',
    bbk: '88.4',
  },
  {
    name: 'Соціальна психологія',
    udk: '316.6',
    bbk: '88.5',
  },
  {
    name: 'Особливі психічні стани та явища',
    udk: '159.96',
    bbk: '88.6',
  },
  {
    name: 'Бібліографія. Бібліографічні покажчики',
    udk: '01',
    bbk: '91',
  },
  {
    name: 'Довідкові видання',
    udk: '030',
    bbk: '92',
  },
  {
    name: 'Серійні видання. Періодика',
    udk: '050',
    bbk: '95',
  },
  {
    name: 'Пиши впоперек!',
    udk: '451',
    bbk: '451',
  },
];
